let firebase = null;

if (process.env.VUE_APP_IS_BROWSER) firebase = require('firebase/app');
else firebase =  eval(`require('firebase-admin')`);

module.exports = firebase;
